import React from 'react';
import { Box, TableHead, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import { Trans, useTranslation } from 'react-i18next';

// Convert makeStyles to styled components
const StyledTableCellHeader = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-root': {
    textAlign: 'center',
    fontWeight: 700,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-root': {},
}));

const StyledEmptyCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-root': {
    padding: '0px',
  },
}));

const StyledDividerCell = styled(TableCell)(({ theme }) => ({
  '&.MuiTableCell-root': {
    borderTop: 'none',
  },
}));

const StyledHeaderText = styled(Typography)(({ theme }) => ({
  color: 'white',
  textAlign: 'center',
}));

// Shared tag map so the <strong> segments inside the translated clinical copy
// keep their bold styling.
const strongTags = { strong: <strong /> };

const PressureInterpretationTableComponent = () => {
  const { t } = useTranslation('alertDetail');

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: 'primary.main',
        borderRadius: '10px',
        padding: '5px',
      }}
    >
      {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
      <StyledHeaderText variant="h5">
        {t('interpretationTable')}
      </StyledHeaderText>

      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '10px',
        }}
      >
        <Table aria-label="simple table">
          <TableHead>
            <StyledEmptyCell />
            <StyledTableCellHeader>
              <Typography>
                <Trans
                  t={t}
                  i18nKey="pressure.columns.peak"
                  components={strongTags}
                />
              </Typography>
            </StyledTableCellHeader>
            <StyledTableCellHeader>
              <Typography>
                <Trans
                  t={t}
                  i18nKey="pressure.columns.constant"
                  components={strongTags}
                />
              </Typography>
            </StyledTableCellHeader>
          </TableHead>
          <TableBody>
            <TableRow>
              <StyledTableCellHeader rowSpan={2}>
                <Typography align="center" sx={{ fontWeight: 'bold' }}>
                  {t('pressure.level1.label')}
                </Typography>
                <React.Fragment>&nbsp;</React.Fragment>
                <Typography align="left">
                  <Trans
                    t={t}
                    i18nKey="pressure.level1.description"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCellHeader>
              <StyledTableCell>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="pressure.level1.peakEntire"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCell>
              <StyledTableCell rowSpan={2}>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="pressure.level1.constant"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCell>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="pressure.level1.peakForefoot"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCellHeader>
                <Typography align="center" sx={{ fontWeight: 'bold' }}>
                  {t('pressure.level2.label')}
                </Typography>
                <React.Fragment>&nbsp;</React.Fragment>
                <Typography align="left">
                  <Trans
                    t={t}
                    i18nKey="pressure.level2.description"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCellHeader>
              <StyledTableCell>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="pressure.level2.peak"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="pressure.level2.constant"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCell>
            </TableRow>
            <TableRow>
              <StyledTableCellHeader>
                <Typography align="center" sx={{ fontWeight: 'bold' }}>
                  {t('pressure.level3.label')}
                </Typography>
                <React.Fragment>&nbsp;</React.Fragment>
                <Typography align="left">
                  <Trans
                    t={t}
                    i18nKey="pressure.level3.description"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCellHeader>
              <StyledTableCell>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="pressure.level3.peak"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography>
                  <Trans
                    t={t}
                    i18nKey="pressure.level3.constant"
                    components={strongTags}
                  />
                </Typography>
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PressureInterpretationTableComponent;
